<template>
  <div class="product" v-bind:class="{hover: isHover && !item.active, active: item.active}" @mouseover="mouseOver" @mouseout="mouseOver">
    <div><img :src="item.img" v-bind:class="{'img-max': isHover && !item.active}"/></div>
    <div style="width: 100%; padding-left: 8px;display: flex; align-items: center; justify-items: center;">
      <span>
        {{ item.name }}
      </span>
    </div>
    <div><img class="arrow" :src="icons.ARROW"/></div>
  </div>
</template>
<script>
import { ICONS } from '@/constants/help-center'

export default {
  name: 'Product',
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      isHover: false,
      icons: ICONS
    }
  },
  methods: {
    mouseOver () {
      this.isHover = !this.isHover
    }
  }
}
</script>
<style >
.centro-de-ayuda .product {
  background: #FFFFFF;
  border: 1.59px solid #F2F2F2;
  box-shadow: 0px 2.89px 2.89px rgba(112, 112, 112, 0.25);
  border-radius: 16.4282px;
  padding-top: 7px;
  padding-left: 18px;
  padding-bottom: 3px;
  max-width: 272px;
  margin-bottom: 21px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
}
.centro-de-ayuda .product.active{
  border: 1.59px solid #0855C4;
  box-shadow: 0px 2.89px 2.89px rgba(112, 112, 112, 0.25);
  border-radius: 16.4282px;
}
.centro-de-ayuda .product.hover span{
  font-family: 'Omnes Regular';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #0855C4;
}
.centro-de-ayuda .product img.img-max{
  width: 48px;
  height: 48px;
}
.centro-de-ayuda .product.hover{
  padding-bottom: 15px;
  padding-top: 10px;
}
.centro-de-ayuda .product span {
  font-family: 'Omnes Regular';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 12px;
  padding-left: 13px;
  color: #454A6C;
}
.centro-de-ayuda .product img.arrow {
  float: right;
  padding: 18px 13px;
}
.centro-de-ayuda .product.hover img.arrow {
  padding-top: 21px;
}
@media only screen and (max-width: 768px) {
  .centro-de-ayuda .product {
    max-width: 100%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help-center/Product.vue